// extracted by mini-css-extract-plugin
export default {"errorWrapper":"Error_errorWrapper__KQHdm","errorHeader":"Error_errorHeader__3bT2q","errorBody":"Error_errorBody__XAY1C","homeLink":"Error_homeLink__Eg7b+"};